var React = require('react');

function OpenedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"23","height":"15","x":".5","y":".5","fill":"#F9F9FB","stroke":"#E4E5EB","rx":"3","key":0}),React.createElement("circle",{"cx":"16","cy":"8","r":"1","fill":"#0A182E","key":1}),React.createElement("circle",{"cx":"8","cy":"8","r":"1","fill":"#0A182E","key":2})]));
}

OpenedIcon.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = OpenedIcon;

OpenedIcon.default = OpenedIcon;
